export default __webpack_public_path__ + "assets/icons/senderPerson.76bb90ac.svg";